import React, { useEffect, useRef, useState } from 'react';
import { BwjEventArgs } from '../../../../framework/entities/bwj-event';
import { IStormDoorModel, StormDoorModel } from '../../../../entities-generated/models/storm-door/storm-door-model';
import { IProductTexture } from '../../../../entities-generated/common/product-texture';
import { ProductDetailPanel } from '../product-detail-panel';

export interface IStormDoorDetailPanelArgs {
  door: IStormDoorModel;
  priceChange: number;
  services: string[];
  selected: IProductTexture | null;
}

interface IStormDoorDetailPanelProps {
  launchPanel: BwjEventArgs<IStormDoorDetailPanelArgs> | undefined;
  onDoorSelected: (door: IStormDoorModel, variant: IProductTexture) => void;
  onIncludedServicesOverlayRequested: (included: string[]) => void;
  includedServicesOnDisplay: boolean;
}

const deriveIncludedServices = (services: string[], handleIncluded: boolean) => {
  const all = [...services];
  if(handleIncluded === false) {
    all.push('Door handle of your choice (usually sold separately with this model - but with us, its included)');
  }
  return all;
}

export const StormDoorDetailPanel: React.FunctionComponent<IStormDoorDetailPanelProps> = (props) => {
  const [showPanel, setShowPanel] = useState(false);
  const doorInfo = useRef<IStormDoorDetailPanelArgs>({ door: new StormDoorModel(), services: [], priceChange: 0, selected: null });
  const { launchPanel } = props;
  const initialVariantSelection = useRef<BwjEventArgs<IProductTexture | null>>(new BwjEventArgs(null));

  useEffect(() => {
    if(!launchPanel || launchPanel.inaccessible()) { return; }

    doorInfo.current = launchPanel.getArgs();
    initialVariantSelection.current = new BwjEventArgs(doorInfo.current.selected);
    setShowPanel(true);
  }, [launchPanel]);

  const onProductChosen = (variant: IProductTexture) => {
    props.onDoorSelected(doorInfo.current.door, variant);
    onClosePanel();
  }

  const onClosePanel = () => {
    if(props.includedServicesOnDisplay) { return; }
    setShowPanel(false);
  }

  const di = doorInfo.current;
  const d = di.door;
  const includedServices = deriveIncludedServices(di.services, d.complete);
  return (
    <ProductDetailPanel
      id={d.id}
      brand={d.brand}
      title={d.description}
      price={d.price}
      averageRating={d.rating > 0 ? d.rating : undefined}
      rating={d.productReview.totalReviewCount > 0 ? d.productReview : undefined}
      keyFeatures={d.sellingPoints}
      includedServices={includedServices}
      imageUrls={d.imageUrls}
      variants={d.textureVariants}
      variantDescriptor={'color'}
      initialVariantSelection={initialVariantSelection.current}
      recommendation={d.recommendation}
      priceChange={di.priceChange}
      chooseProductButtonText={'Get this door'}
      onProductChosen={onProductChosen}
      chooseVariantButtonText={'Pick color'}
      showPanel={showPanel}
      onClosePanel={onClosePanel}
      onIncludedServicesOverlayRequested={props.onIncludedServicesOverlayRequested}
    />
  );
};
